// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, GradientFill, LayerInfo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  Descriptor = require('../descriptor');

  module.exports = GradientFill = (function(superClass) {
    extend(GradientFill, superClass);

    function GradientFill() {
      return GradientFill.__super__.constructor.apply(this, arguments);
    }

    GradientFill.shouldParse = function(key) {
      return key === 'GdFl';
    };

    GradientFill.prototype.parse = function() {
      this.file.seek(4, true);
      return this.data = new Descriptor(this.file).parse();
    };

    return GradientFill;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/gradient_fill.js
// module id = 63
// module chunks = 0